import InfoSection from '../HorizontalInfoSection';
import InfoTable from '../InfoTable';
import InfoDescription from '../InfoDescription';
import React from 'react';

function InfoContainer(): React.JSX.Element {
    return (
        <div>
            <InfoSection />
            <InfoDescription />
            <InfoTable />
        </div>
    );
}

export default InfoContainer;
